<template>
  <div class="row">
    <div class="col-12">
      <table class="table table-sm table-borderless table-striped">
        <tbody>
        <tr>
          <td>Invoice No</td>
          <td>{{docket.docNo}}</td>

          <td>Invoice Date</td>
          <td>{{docket.docDt | date}}</td>
        </tr>
        <tr>
          <td>Customer</td>
          <td>{{docket.customerName}}</td>
          <td>Transporter</td>
          <td>
            <span v-if="docket.transporter">{{docket.transporter.name}}</span>
          </td>
        </tr>
        <tr>
          <td>LR No</td>
          <td>{{docket.lrNo}}</td>

          <td>LR Dt</td>
          <td>{{docket.lrDt | date}}</td>
        </tr>
        <tr>
          <td v-if="docket.returnLrNo">Return LR No</td>
          <td v-if="docket.returnLrNo">{{docket.returnLrNo}}</td>
          <td>POD Status</td>
          <td>
            <p-o-d-status v-bind:docket="docket"></p-o-d-status>
          </td>
        </tr>
        <tr>
          <td colspan="1">Delivery Status</td>
          <td colspan="3">
            <delivery-status :docket="docket"></delivery-status>
          </td>
        </tr>
        </tbody>

      </table>
      <div class="row mb-3" v-if="comments && comments.length > 0">
        <div class="col-12">
          <h4>Comments</h4>
        </div>
        <div class="col-12">

          <b-list-group>
            <b-list-group-item v-for="c of comments" :key="c.id">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">{{c.commentBy.userName}}</h5>
                <small>{{c.commentAt|datetime}}</small>
              </div>
              <p class="mb-1">{{c.comment}}</p>
            </b-list-group-item>
          </b-list-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PODStatus from '@/components/shared/PODStatus'
import DeliveryStatus from '@/components/shared/DeliveryStatus'

export default {
  name: 'BasicDocket',
  props: ['docket', 'comments'],
  components: {PODStatus, DeliveryStatus},
  data () {
    return {}
  },
  computed: {
  },
  methods: {}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/shared/BasicDocket.vue